import ASLogo from "../graphics/ASLogo";

const HomeFooter = () => {
  return (
    <footer className="py-5 mt-auto text-muted small fw-light">
      <div className="container-xxl">
        <div className="row gy-2">
          <a
            className="col col-xs-3 text-muted"
            href="http://www.advokatsamfundet.dk"
          >
            <ASLogo width={150} />
          </a>
          <div className="col-8 d-flex flex-wrap align-items-center justify-content-xl-center">
            <span>Advokatsamfundet -&nbsp;</span>
            <address className="m-0">
              Kronprinsessegade 28 - 1306 København K -&nbsp;
              <a
                className="fw-semibold text-muted"
                href="http://www.advokatsamfundet.dk"
              >
                www.advokatsamfundet.dk
              </a>
            </address>
          </div>
          <div className="col-auto flex-xl-grow-1">&nbsp;</div>
        </div>
      </div>
    </footer>
  );
};

export default HomeFooter;
